import { Component } from 'react'
import { withRouter } from 'react-router-dom'

class ScrollToTopComponent extends Component {
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location)
			setTimeout(window.scrollTo(0, 0), 0)
	}

	render() {
		return this.props.children
	}
}

export const ScrollToTop = withRouter(ScrollToTopComponent)
